import StyledSection from "../pages/Page-styles/StyledSection";

const Home = () => (
  <StyledSection>
      <div> <h3>Welcome to JavaScript array methods studying!</h3>  </div>
  </StyledSection>
);
export default Home;
